import {ControlValueAccessor} from "@angular/forms";
import {ObservableOnDestroyMixin} from "../../../mixins/observable-on-destroy.mixin";
import {EmptyMixin} from "../../../mixins/empty.mixin";

export abstract class FormControlBaseComponent<TValueType> extends ObservableOnDestroyMixin(EmptyMixin) implements ControlValueAccessor {
    protected readonly DEFAULT_VALUE: TValueType;

    private _controlValue: TValueType;

    public isDisabled: boolean = false;

    private _onChange: any = () => {
    }

    private _onTouched: any = () => {
    }

    protected get controlValue(): TValueType {
        return this._controlValue;
    }

    protected set controlValue(value: TValueType) {
        this._controlValue = value;
    }

    protected constructor(defaultValue: TValueType) {
        super();
        this.DEFAULT_VALUE = defaultValue;
        this.controlValue = this.DEFAULT_VALUE;
    }

    public registerOnChange(onChangeFn: any): void {
        this._onChange = onChangeFn;
    }

    public registerOnTouched(onTouchedFn: any): void {
        this._onTouched = onTouchedFn;
    }

    public setDisabledState(isDisabled: boolean): void {
        this.isDisabled = isDisabled;
    }

    public writeValue(value: any): void {
        this.controlValue = value;
    }

    protected writeNewValue(value: TValueType): void {
        if (value !== undefined) {
            this.writeValue(value);
            this._onChange(value);
        }
    }
}
